import React from "react";
import { Container, Box, Typography } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const campus = [
  { id: 1, name: "Kalasalingam University, Krishnan Kovil" },
  { id: 2, name: "Sapthagiri Engineering College, Bangalore" },
  { id: 3, name: "Saveetha Engineering College, Chennai" },
  { id: 4, name: "SRM Valliammai Engineering College, Chennai" },
  { id: 5, name: "Rajiv Gandhi College of Engineering & Technology, Pudhucherry" },
  { id: 6, name: "Christ College of Engineering & Technology, Pudhucherry" },
  { id: 7, name: "Kamaraj College of Engineering & Technology, Virudhunagar" },
  { id: 8, name: "Mepco Schlenk Engineering College, Sivakasi" },
  { id: 9, name: "Muthayammal Engineering College, Namakkal" },
  { id: 11, name: "K Ramakrishnan College of Engineering, Trichy" },
  { id: 12, name: "C Abdul Hakeem College of Engineering and Technology, Vellore" },
  { id: 13, name: "KSR Institution, Tiruchengode" },
  { id: 14, name: "Mahendra Engineering College for Women, Tiruchengode" },
  { id: 15, name: "Bharathiyar Engineering College for Women, Thalaivasal" },
  { id: 16, name: "AVS Engineering College, Salem" },
  { id: 17, name: "Bharath University, Chennai" },
  { id: 18, name: "Bannariamman Institute of Technology, Sathyamangalam" },
  { id: 19, name: "Builders Engineering College, Erode" },
  { id: 20, name: "National Engineering College, Kovilpatti" },
  { id: 21, name: "SDM Institute of Technology, Ujire, Karnataka" },
  { id: 22, name: "Vignan Institute of Information Technology, Vishakapatnam" },
  { id: 23, name: "Sri Venkatesa Perumal Engineering and Technology, Puttur" },
  { id: 24, name: "Mangalore Institute of Technology and Engineering, Mangalore, Karnataka" },
  { id: 25, name: "N.M.A.M. Institute of Technology, Nitte, Udupi, Karnataka" },
];

// A single institution card. Reuses the shared card hover polish + a brand icon.
const CampusTile = ({ item }) => (
  <Box
    sx={{
      ...ui.card,
      flex: "0 0 auto",
      width: { xs: 230, sm: 250 },
      minHeight: 120,
      p: 2.25,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: 1.2,
    }}
  >
    <Box
      sx={{
        ...ui.iconTile,
        width: 34,
        height: 34,
      }}
    >
      <SchoolIcon sx={{ fontSize: 19 }} />
    </Box>
    <Typography
      sx={{
        fontFamily: fonts.body,
        fontWeight: 600,
        color: colors.navy,
        fontSize: "0.86rem",
        lineHeight: 1.4,
      }}
    >
      {item.name}
    </Typography>
  </Box>
);

// One infinite row. Track is duplicated for a seamless loop; the duplicate is
// aria-hidden so screen readers announce each institution only once.
const MarqueeRow = ({ items, direction }) => {
  const trackClass = `marquee__track marquee__track--${direction}`;
  return (
    <Box className="marquee" sx={{ py: 1.25 }}>
      <Box className={trackClass}>
        {items.map((item) => (
          <CampusTile key={`a-${item.id}`} item={item} />
        ))}
      </Box>
      <Box className={trackClass} aria-hidden="true">
        {items.map((item) => (
          <CampusTile key={`b-${item.id}`} item={item} />
        ))}
      </Box>
    </Box>
  );
};

const CampusCard = () => {
  // Split into two rows that scroll in opposite directions.
  const mid = Math.ceil(campus.length / 2);
  const rowTop = campus.slice(0, mid);
  const rowBottom = campus.slice(mid);

  return (
    <section id="campus-section" className="campus-section">
      <Box sx={{ py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Institutions & Campuses"
            title="Where Our Experts Have Delivered"
            subtitle="A growing network of engineering colleges and universities across South India and beyond that our team has partnered with."
          />
        </Container>

        {/* Full-bleed two-row marquee, rows gliding in opposite directions */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, md: 1.5 } }}>
          <MarqueeRow items={rowTop} direction="left" />
          <MarqueeRow items={rowBottom} direction="right" />
        </Box>
      </Box>
    </section>
  );
};

export default CampusCard;
